import { SET_ROLES_AND_RIGHTS } from "../constants/index";

export const setRolesAndRights = (roles) => ({
  type: SET_ROLES_AND_RIGHTS,
  roles,
});
